import { useMemo } from "react";

import { type WorkingDaysInfo, getWorkingDaysInfo } from "~/utils/workingDays";

export function useWorkingDays(year: number, month: number): WorkingDaysInfo {
  return useMemo(() => getWorkingDaysInfo(year, month), [year, month]);
}
